import React, { useState } from "react";
import { ExternalLink } from "lucide-react";

export default function LogoTile({ item }) {
  const [broken, setBroken] = useState(false);
  const initial = item.name?.charAt(0)?.toUpperCase() || "?";

  return (
    <a
      href={item.url}
      target="_blank"
      rel="noreferrer"
      className="logo-tile group p-5 flex flex-col gap-3 relative"
      data-testid={`admin-tile-${item.id}`}
    >
      <div className="flex items-start justify-between">
        <div className="w-14 h-14 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center overflow-hidden">
          {!broken ? (
            <img
              src={item.logo}
              alt={item.name}
              onError={() => setBroken(true)}
              className="w-10 h-10 object-contain"
              loading="lazy"
            />
          ) : (
            <div className="w-10 h-10 rounded-lg bg-indigo-100 text-indigo-600 font-display font-bold flex items-center justify-center text-lg">
              {initial}
            </div>
          )}
        </div>
        <ExternalLink size={14} className="text-slate-400 group-hover:text-indigo-500 transition-colors" />
      </div>
      <div>
        <p className="font-display font-semibold text-slate-900 group-hover:text-indigo-600 transition-colors">
          {item.name}
        </p>
        {item.tagline && <p className="text-xs text-slate-500 mt-1 line-clamp-2">{item.tagline}</p>}
      </div>
      {item.highlight && (
        <span className="absolute top-3 right-3 text-[10px] font-semibold px-2 py-0.5 rounded-full bg-yellow-200 text-yellow-900">
          RECOMMANDÉ
        </span>
      )}
    </a>
  );
}
